import { render } from "./OurDestination.vue?vue&type=template&id=541b4a52"
import script from "./OurDestination.vue?vue&type=script&lang=js"
export * from "./OurDestination.vue?vue&type=script&lang=js"

import "./OurDestination.vue?vue&type=style&index=0&id=541b4a52&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__